import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import ReportView from "@/components/ReportView";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

export default function SampleReportPublic() {
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/sample-report")
      .then((res) => setReport(res.data))
      .catch(() => setReport(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="public-sample-report-page">
      <header className="border-b border-slate-200 bg-white sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <BrandLogo className="h-8" />
          </div>
          <button
            type="button"
            data-testid="sample-report-back-to-home-button"
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-indigo-600"
          >
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </button>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-12">
        {loading && <p className="text-center text-sm text-slate-400" data-testid="public-sample-report-loading">Generating your preview sample report…</p>}
        {!loading && !report && <p className="text-center text-sm text-slate-400" data-testid="public-sample-report-empty">Sample report is not available right now. Please try again shortly.</p>}
        {!loading && report && <ReportView report={report} isSample translateUrl="/public/sample-report/translate" />}
      </main>
    </div>
  );
}
